import { ScrollItem } from "./ScrollItem";

import Event = createjs.Event;

/**
 *  @author Nils
 */
export class ScrollItemEvent extends Event {
    public static CLICK: string = "click";
    public static ROLL_OVER: string = "roll_over";
    public static ROLL_OUT: string = "roll_out";
    public static ON_SCROLL: string = "on_scroll";

    public scrollItem: ScrollItem;
    public originTarget: any;

    constructor(type: string, scrollItem: ScrollItem, origin: any, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);
        this.scrollItem = scrollItem;
        this.originTarget = origin;
    }
}
